module.exports = __webpack_public_path__ + "static/img/flexible_term_elegant.cea819a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/flexible_term_elegant.png
// module id = 1697
// module chunks = 5